module.exports = __webpack_public_path__ + "img/bb-most-common.461125f.png";